/**
 * external libraries.
 */
import {
  Breadcrumb,
  Spinner,
  FormSelect,
  Modal,
  Dropdown,
  Alert,
  Nav,
  Collapse,
  Tabs,
  Table,
  Pagination,
  Button,
  Progress,
  ImagePlugin,
  Card,
  InputGroup,
  ListGroupPlugin
} from 'bootstrap-vue/es/components'

import Vue from 'vue'
import LiquorTree from 'liquor-tree'
import VueQuillEditor from 'vue-quill-editor'

import Carousel3d from 'vue-carousel-3d'
import Multiselect from 'vue-multiselect'
import Draggable from 'vuedraggable'
import {
  Material,
  Compact,
  Swatches,
  Slider,
  Sketch,
  Chrome,
  Photoshop
} from 'vue-color'

import VueLazyload from 'vue-lazyload'

/**
 * internal libraries.
 */
import List from '~/components/components/List.vue'
import ItemDetail from '~/components/components/ItemDetail.vue'
import Tree from '~/components/components/Tree.vue'

import InputControl from '~/components/composites/InputControl.vue'
import DisplayControl from '~/components/composites/DisplayControl.vue'
import XdataInsertRowControl from '~/components/composites/XdataInsertRowControl.vue'
import XdataUpdateRowControl from '~/components/composites/XdataUpdateRowControl.vue'
import AdditionalFieldControl from '~/components/composites/AdditionalFieldControl.vue'
import AdditionalFieldSampleControl from '~/components/composites/AdditionalFieldSampleControl.vue'
import AdditionalFieldInfoControl from '~/components/composites/AdditionalFieldInfoControl.vue'
import MultilanguageTextConverterControl from '~/components/composites/MultilanguageTextConverterControl.vue'

import ImageSlider3d from '~/components/primitives/ImageSlider3d.vue'
import I18n from '~/components/primitives/I18n.vue'
import MemoControl from '~/components/components/MemoControl.vue'
import Memo from '~/components/primitives/Memo.vue'
import MemoComment from '~/components/primitives/MemoComment.vue'
import CheckAllButton from '~/components/primitives/CheckAllButton.vue'
import GlobalMap from '~/components/primitives/GlobalMap.vue'
import ImageViewer from '~/components/primitives/ImageViewer.vue'
import FileIcon from '~/components/primitives/FileIcon.vue'
import CenteredImage from '~/components/primitives/CenteredImage.vue'
import HtmlEditor from '~/components/primitives/HtmlEditor.vue'
import EarnPoint from '~/components/primitives/EarnPoint.vue'
import Point from '~/components/primitives/Point.vue'
import NameInput from '~/components/primitives/NameInput.vue'
import SimpleDatePicker from '~/components/primitives/SimpleDatePicker.vue'
import SimpleYearPicker from '~/components/primitives/SimpleYearPicker.vue'

import FilePreview from '~/components/primitives/FilePreview.vue'
import MultifileUploader from '~/components/primitives/MultifileUploader.vue'
import FileUploader from '~/components/primitives/FileUploader.vue'
import PigTailLabel from '~/components/primitives/PigTailLabel.vue'
import DatetimePicker from 'vue-bootstrap-datetimepicker'
import IconSelector from '~/components/primitives/IconSelector.vue'
import PageSelector from '~/components/primitives/PageSelector.vue'
import BbsSelector from '~/components/primitives/BbsSelector.vue'
import ServiceSelector from '~/components/primitives/ServiceSelector.vue'
import CategorySelector from '~/components/primitives/CategorySelector.vue'
import UserSelector from '~/components/primitives/UserSelector.vue'
import ProfileImage from '~/components/primitives/ProfileImage.vue'
import ColorPicker from '~/components/primitives/ColorPicker.vue'
import CreditCard from '~/components/primitives/CreditCard.vue'
import MyVimeoPlayer from '~/components/primitives/MyVimeoPlayer.vue'
import MyYoutubePlayer from '~/components/primitives/MyYoutubePlayer.vue'
import MultipleSelect from '~/components/primitives/MultipleSelect.vue'
import HierarchySelector from '~/components/primitives/HierarchySelector'
import CurrencySelector from '~/components/primitives/CurrencySelector.vue'
import BarChart from '~/components/primitives/BarChart.vue'
import VueTelInput from 'vue-tel-input'
import VueCurrencyInput from 'vue-currency-input'
import Quill from 'quill'

Vue.use(VueLazyload)
Vue.use(VueTelInput)
Vue.use(Breadcrumb)
Vue.use(Spinner)
Vue.use(FormSelect)
Vue.use(Modal)
Vue.use(Alert)
Vue.use(Dropdown)
Vue.use(Nav)
Vue.use(Collapse)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Progress)
Vue.use(ImagePlugin)
Vue.use(Card)
Vue.use(InputGroup)
Vue.use(ListGroupPlugin)
Vue.use(Carousel3d)
Vue.use(VueQuillEditor)
Vue.use(VueCurrencyInput)
Vue.use(BarChart)

Vue.component('List', List)
Vue.component('ItemDetail', ItemDetail)
Vue.component('Tree', Tree)

Vue.component('XdataInsertRowControl', XdataInsertRowControl)
Vue.component('XdataUpdateRowControl', XdataUpdateRowControl)
Vue.component('AdditionalFieldInfoControl', AdditionalFieldInfoControl)
Vue.component('AdditionalFieldSampleControl', AdditionalFieldSampleControl)
Vue.component('AdditionalFieldControl', AdditionalFieldControl)
Vue.component(
  'MultilanguageTextConverterControl',
  MultilanguageTextConverterControl
)
Vue.component('MyVimeoPlayer', MyVimeoPlayer)
Vue.component('MyYoutubePlayer', MyYoutubePlayer)
Vue.component('InputControl', InputControl)
Vue.component('DisplayControl', DisplayControl)
Vue.component('IconSelector', IconSelector)
Vue.component('PageSelector', PageSelector)
Vue.component('BbsSelector', BbsSelector)
Vue.component('ServiceSelector', ServiceSelector)
Vue.component('CategorySelector', CategorySelector)
Vue.component('UserSelector', UserSelector)
Vue.component('LiquorTree', LiquorTree)
Vue.component('Multiselect', Multiselect)
Vue.component('CenteredImage', CenteredImage)
Vue.component('ImageSlider3d', ImageSlider3d)
Vue.component('ImageViewer', ImageViewer)
Vue.component('I18n', I18n)
Vue.component('MemoControl', MemoControl)
Vue.component('Memo', Memo)
Vue.component('MemoComment', MemoComment)
Vue.component('CheckAllButton', CheckAllButton)
Vue.component('GlobalMap', GlobalMap)
Vue.component('FileIcon', FileIcon)
Vue.component('PigTailLabel', PigTailLabel)
Vue.component('DatetimePicker', DatetimePicker)
Vue.component('FilePreview', FilePreview)
Vue.component('MultifileUploader', MultifileUploader)
Vue.component('FileUploader', FileUploader)
Vue.component('HtmlEditor', HtmlEditor)
Vue.component('Point', Point)
Vue.component('NameInput', NameInput)
Vue.component('SimpleDatePicker', SimpleDatePicker)
Vue.component('SimpleYearPicker', SimpleYearPicker)
Vue.component('EarnPoint', EarnPoint)
Vue.component('ProfileImage', ProfileImage)
Vue.component('Draggable', Draggable)
Vue.component('MaterialColorPicker', Material)
Vue.component('CompactColorPicker', Compact)
Vue.component('SwatchesColorPicker', Swatches)
Vue.component('SliderColorPicker', Slider)
Vue.component('SketchColorPicker', Sketch)
Vue.component('ChromeColorPicker', Chrome)
Vue.component('PhotoshopColorPicker', Photoshop)
Vue.component('CreditCard', CreditCard)
Vue.component('MultipleSelect', MultipleSelect)
Vue.component('HierarchySelector', HierarchySelector)
Vue.component('CurrencySelector', CurrencySelector)

Vue.component('ColorPicker', ColorPicker)
Vue.config.ignoredElements = ['t', 'template-rendering-area']

const Link = Quill.import('formats/link')

class CustomLink extends Link {
  static sanitize(url) {
    if (url.startsWith('unistars:')) {
      return url
    } else {
      return super.sanitize(url)
    }
  }
}
Quill.register(CustomLink)
